// extracted by mini-css-extract-plugin
module.exports = {"playlist-title":"PlaylistCategoryFooter_playlist-title__1c280","playlist-footer":"PlaylistCategoryFooter_playlist-footer__3oFRt"};